import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Usuarios, IUsuario } from '../../../../models/usuarios.model';
import { FormGroup } from '@angular/forms';
import { UsersService } from '../../../../models/usuarios.service';
import { Subscription } from 'rxjs';



@Component({
    selector: 'cadastro-login-dialog',
    templateUrl: './cadastro.login.dialog.html',
    styleUrls: ['./cadastro.login.dialog.scss']
})
export class CadastroLoginDialog implements OnInit, OnDestroy {
    item: any;
    form;
    eventLogin: Subscription;
    message: string = '';
    checkedRegras: boolean = false;
    constructor(
        private users: UsersService,
        private db: AngularFirestore,
        private dialogRef: MatDialogRef<CadastroLoginDialog>,
        @Inject(MAT_DIALOG_DATA) data) {
        this.item = data;
        this.eventLogin = users.loginChange.subscribe(
            r => {
                this.item = r;
                this.dialogRef.close(this.item);
            }
        )
    }

    ngOnInit(): void {

        // this.form = new FormGroup({
        //    email: new FormControl()
        // });

    }
    ngOnDestroy() {
        this.eventLogin.unsubscribe();
    }

   doRegras(event){
       if (event.checked)
         this.message='';
   }
    ok() {
        if (!this.checkedRegras) {
           this.message = 'Requer aceite nas regras de privacidade'
        } else
            if (this.item.nome > "") {
                this.users.addUser(this.item);
            }
    }

    cancelar() {
        this.dialogRef.close();
    }

}
